export const NewBookMarkType = 1;
export const ExistBookMarkType = 0;
export const MaxTemplateNum = 6;

export enum StoreServiceMode {
  BOOKMARK = 'bookmark', // 书签
}
